export interface TranslationState {
  selectedLanguage: string;
  languageJson: any;
  error: any;
}

export const initState: TranslationState = {
  selectedLanguage: null,
  languageJson: null,
  error: null,
};
